"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.variants = void 0;
var colors_1 = require("./colors");
var stylePacks_1 = require("./stylePacks");
exports.variants = {
    buttons: {
        primary: __assign({}, stylePacks_1.primaryButtonStyle),
        outlinePrimary: __assign({}, stylePacks_1.outlinePrimaryButtonStyle),
        dark: __assign({}, stylePacks_1.darkButtonStyle),
        outlineDark: __assign({}, stylePacks_1.outlineDarkButtonStyle),
        light: __assign({}, stylePacks_1.lightButtonStyle),
        outlineClear: __assign({}, stylePacks_1.clearButtonStyle),
    },
    links: {
        primary: {
            color: colors_1.colors.primary,
        },
        button: __assign({}, stylePacks_1.primaryButtonStyle),
        darkButton: __assign({}, stylePacks_1.darkButtonStyle),
        lightButton: __assign({}, stylePacks_1.lightButtonStyle),
        outlineDarkButton: __assign({}, stylePacks_1.outlineDarkButtonStyle),
        outlineClearButton: __assign({}, stylePacks_1.clearButtonStyle)
    },
    inputs: {
        light: __assign(__assign({}, stylePacks_1.baseInput), { color: colors_1.colors.text, borderBottom: '1px solid hsl(0, 0%, 20%)', '&:focus': {
                borderBottom: '1px solid hsl(0, 0%, 50%)'
            } }),
        dark: __assign(__assign({}, stylePacks_1.baseInput), { color: colors_1.colors.contrastText, borderBottom: '1px solid hsl(0, 0%, 20%)', '&:focus': {
                borderBottom: '1px solid hsl(0, 0%, 50%)',
            } }),
        primary: __assign({}, stylePacks_1.primaryInput),
        v2: __assign({}, stylePacks_1.v2Input)
    },
    selects: {
        primary: __assign({ 
            // for padding to work in <select> in Safari
            appearance: 'none' }, stylePacks_1.baseInput),
        v2: __assign({ 
            // for padding to work in <select> in Safari
            appearance: 'none' }, stylePacks_1.v2Input)
    }
};
